// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  width: 100%;
  padding: 20px 0px 20px 20px;
  margin-top: 20px;
}

.content {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
}

.sub-content {
  padding: 10px 0px 15px 0px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}

.cardTitle {
  font-weight: 600;
  margin-bottom: 1%;
}

.dateTime {
  margin-top: 2%;
  font-weight: 600;
}

.label-text {
  font-weight: 600;
}

.text-style {
  color: var(--color-card-text);
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/shared/components/pick-up/pick-up.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,2BAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AACF;;AACA;EACE,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAEF;;AAAA;EACE,gBAAA;EACA,iBAAA;AAGF;;AADA;EACE,cAAA;EACA,gBAAA;AAIF;;AAFA;EACE,gBAAA;AAKF;;AAFA;EACE,6BAAA;AAKF","sourcesContent":[".card {\n  width: 100%;\n  padding: 20px 0px 20px 20px;\n  margin-top: 20px;\n}\n\n.content {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n}\n.sub-content {\n  padding: 10px 0px 15px 0px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n}\n.cardTitle {\n  font-weight: 600;\n  margin-bottom: 1%;\n}\n.dateTime {\n  margin-top: 2%;\n  font-weight: 600;\n}\n.label-text {\n  font-weight: 600;\n}\n\n.text-style{\n  color: var(--color-card-text);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
